export default {
      id: "big-arrow-left-usage",
      viewBox: "0 0 99 32",
      url: "../../assets/" + "sprite.svg#big-arrow-left-usage",
      toString: function () {
        return this.url;
      }
    }